import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent, PageHeader, EmptyState } from '@/components/ui'
import { Activity as ActivityIcon } from 'lucide-react'

export const Route = createFileRoute('/_app/activity')({
  component: ActivityPage,
})

function ActivityPage() {
  return (
    <>
      <PageHeader
        title="Actividad"
        description="Audit log global — quién hizo qué cuándo"
      />
      <div className="p-8">
        <Card>
          <CardContent className="p-0">
            <EmptyState
              title="Audit log vacío"
              description="La tabla audit_logs está creada en el schema. Falta el middleware que escriba entradas en cada acción admin (próxima iteración). Una vez activado, esta vista mostrará: usuario, acción, tenant afectado, cambios (diff JSON), IP, user agent, timestamp."
            />
            <div className="border-t border-border p-4 text-xs text-muted-foreground flex items-center gap-2">
              <ActivityIcon className="size-4" />
              <span>Endpoint backend: <code className="text-foreground">GET /api/admin/audit-logs</code> — pendiente</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
